import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=38560edc&scoped=true&"
import script from "./UserManage.vue?vue&type=script&lang=js&"
export * from "./UserManage.vue?vue&type=script&lang=js&"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=38560edc&scoped=true&lang=css&"
import style1 from "./UserManage.vue?vue&type=style&index=1&id=38560edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38560edc",
  null
  
)

export default component.exports